<template>
  <v-card>
    <s-crud
      :config="config"
      title="Comparación de Pesos de Recepción Fresco"
      :filter="filter"
      search-input
      :singleRow="false"
      ref="scrudFreshReceptionWeightComparison"
      @rowSelected="onRowSelected($event)"
    >
      <template v-slot:options>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" small color="red darken-2" :loading="loadingPdf" @click="onGeneratePdfFromToolbar()">
              <v-icon small>mdi-file-pdf-box</v-icon>
            </v-btn>
          </template>
          <span>Generar PDF (Seleccionados o Todos)</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" small color="primary" :loading="loadingMail" @click="onOpenEmailModalFromToolbar()">
              <v-icon small>mdi-receipt-text-send-outline</v-icon>
            </v-btn>
          </template>
          <span>Enviar por Correo</span>
        </v-tooltip>
      </template>

      <template v-slot:filter>
        <v-container fluid>
          <v-row style="margin-bottom: 5px">
            <v-col cols="12" md="3">
              <s-date
                label="Fecha Inicio"
                v-model="filter.BeginDate"
                clearable
              ></s-date>
            </v-col>

            <v-col cols="12" md="3">
              <s-date
                label="Fecha Fin"
                v-model="filter.EndDate"
                clearable
              ></s-date>
            </v-col>

            <v-col cols="12" md="6">
              <s-select-producer
                label="Productor"
                v-model="filter.PrdID"
                clearable
              ></s-select-producer>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:HvsDate="{ row }">
        {{ row && row.HvsDate ? $moment(row.HvsDate).format($const.FormatDateView || 'DD/MM/YYYY') : '' }}
      </template>

      <template v-slot:RcfDateReception="{ row }">
        {{ row && row.RcfDateReception ? $moment(row.RcfDateReception).format($const.FormatDateView || 'DD/MM/YYYY') : '' }}
      </template>
    </s-crud>

    <!-- Modal de Vista Previa y Envío de Correo con PDF Adjunto -->
    <v-dialog v-model="dialogPreviewMail" persistent max-width="750">
      <v-card>
        <s-toolbar
          label="Vista Previa de Correo"
          dark
          color="#8e8f91"
          close
          @close="dialogPreviewMail = false"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn text small style="margin-right: 5px" v-on="on" @click="dialogPreviewMail = false">
                <v-icon style="font-size: 18px">mdi-arrow-left</v-icon>
              </v-btn>
            </template>
            <span>Regresar</span>
          </v-tooltip>
        </s-toolbar>

        <v-container>
          <v-row>
            <v-col>
              <div class="email-container">
                <div class="email-header">
                  <div style="display: flex; align-items: center; gap: 10px">
                    <h1 class="email-title">Sunshine Export: Reporte Comparativo de Pesos</h1>
                    <span class="email-label">Borrador</span>
                  </div>
                </div>

                <div class="sender-info">
                  <div class="profile-image">
                    <img src="/static/logo_sp.png" width="160" />
                  </div>
                  <div class="sender-details">
                    <div class="sender-email">notificaciones@sunshineperu.com</div>
                    <div class="recipient">para destinatario</div>
                  </div>
                </div>

                <div class="email-content">
                  <!-- Cuerpo editable de correo -->
                  <div style="display: flex; flex-direction: column; gap: 10px; margin-bottom: 20px">
                    <div v-show="!isEditing" style="display: flex; gap: 10px">
                      <div style="flex: 1" v-html="textContent" class="email-preview-content"></div>
                      <div>
                        <v-icon style="cursor: pointer" @click="enableEditing">mdi-pencil</v-icon>
                      </div>
                    </div>

                    <div v-show="isEditing">
                      <div id="editor-reception"></div>
                      <v-btn small color="success" block @click="saveText" class="mt-2">
                        Guardar Cambios
                        <v-icon small right>mdi-content-save</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <div class="email-divider"></div>

                  <!-- Destinatario -->
                  <div class="recipient-section" style="margin-bottom: 20px">
                    <label class="email-label d-block mb-1">Correo destinatario:</label>
                    <div
                      v-show="!isEditingEmail"
                      class="email-value"
                      @click="enableEmailEditing"
                      style="cursor: text; color: #1976d2; text-decoration: underline"
                    >
                      {{ selectedEmail || "Haga clic para ingresar correo" }}
                    </div>
                    <v-text-field
                      v-show="isEditingEmail"
                      v-model="selectedEmail"
                      placeholder="ejemplo@productor.com"
                      outlined
                      hide-details
                      dense
                      @blur="saveEmailText"
                      @keyup.enter="saveEmailText"
                      ref="emailInput"
                    ></v-text-field>
                  </div>

                  <div class="email-divider"></div>

                  <!-- Tarjeta visual de Archivo Adjunto (PDF) -->
                  <div class="attachment-section">
                    <label class="email-label d-block mb-2">Archivo Adjunto (PDF):</label>
                    <v-card outlined class="pa-3 d-flex align-center" style="background-color: #f9f9f9; border-radius: 6px">
                      <v-icon color="red darken-2" large class="mr-3">mdi-file-pdf-box</v-icon>
                      <div class="flex-grow-1">
                        <div class="font-weight-bold caption text-truncate" style="max-width: 450px">
                          {{ pdfAttachmentName }}
                        </div>
                        <div class="grey--text text--darken-1 caption">Documento PDF A5 (Comparativo de Pesos)</div>
                      </div>
                      <v-btn icon small color="primary" @click="downloadPdfPreview()" title="Descargar / Vista Previa">
                        <v-icon small>mdi-download</v-icon>
                      </v-btn>
                    </v-card>
                  </div>

                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-btn
                block
                color="success"
                :loading="sendingMail"
                @click="sendMailWithPdfAttachment"
              >
                <v-icon left>mdi-send</v-icon> Enviar Correo con PDF Adjunto
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import ReceptionFreshService from "@/services/FreshProduction/ReceptionFreshService";
import SSelectProducer from "@/components/HarvestSchedule/SSelectProducer";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "FreshReceptionWeightComparison",
  components: {
    SSelectProducer,
  },
  data() {
    return {
      loadingPdf: false,
      loadingMail: false,
      sendingMail: false,
      dialogPreviewMail: false,
      selectedRows: [],
      textContent: "",
      isEditing: false,
      quill: null,
      selectedEmail: "",
      isEditingEmail: false,
      pdfAttachmentBase64: "",
      pdfAttachmentName: "",
      pdfDocInstance: null,
      filter: {
        BeginDate: null,
        EndDate: null,
        PrdID: null,
      },
      config: {
        service: {
          pagination: (parameters, requestID) => {
            return ReceptionFreshService.FreshReceptionWeightComparison(parameters, requestID);
          },
        },
        model: {
          RcfID: "ID",
          EmailProducer: "",
          RcfWeightGuide: "decimal",
          WbbNetWeight: "decimal",
          FltHectares: "decimal",
          FltPlants: "number",
          FltVolume: "decimal",
          FltJabasPotential: "number",
        },
        headers: [
          { text: "F. Cosecha", value: "HvsDate" },
          { text: "F. Recepción", value: "RcfDateReception" },
          { text: "Productor", value: "PrdCardName" },
          { text: "N° Guía Remisión", value: "RcfNumberReferralGuide" },
          { text: "Peso Guía (kg)", value: "RcfWeightGuide", align: "right" },
          { text: "Peso Balanza (kg)", value: "WbbNetWeight", align: "right" },
          { text: "Fundo", value: "FagName" },
          { text: "Lote", value: "FltName" },
          { text: "Dirección Fundo", value: "FagAddress" },
          { text: "Zona", value: "ZonIDText" },
          { text: "Sub Zona", value: "SzoIDText" },
        ],
      },
    };
  },
  methods: {
    onRowSelected(selection) {
      const arr = Array.isArray(selection) ? selection : (selection ? [selection] : []);
      if (arr.length > 1) {
        const lastSelected = [arr[arr.length - 1]];
        this.selectedRows = lastSelected;
        if (this.$refs.scrudFreshReceptionWeightComparison) {
          this.$refs.scrudFreshReceptionWeightComparison.selected = lastSelected;
        }
      } else {
        this.selectedRows = arr;
      }
    },
    onGenerateSinglePdf(row) {
      if (!row) return;
      this.buildPdfDocument([row]);
    },
    onOpenEmailModalSingleRow(row) {
      if (!row) return;
      this.prepareEmailModalData([row]);
      this.dialogPreviewMail = true;
    },
    async onGeneratePdfFromToolbar() {
      if (this.selectedRows && this.selectedRows.length > 0) {
        this.buildPdfDocument(this.selectedRows);
      } else {
        await this.onGeneratePdf();
      }
    },
    async onOpenEmailModalFromToolbar() {
      let rowsToProcess = [];
      if (this.selectedRows && this.selectedRows.length > 0) {
        rowsToProcess = this.selectedRows;
      } else {
        this.loadingMail = true;
        try {
          const userId = this.$fun.getUserID();
          const params = {
            filter: { ...this.filter },
            draw: 1,
            start: 0,
            length: 10000,
            order: [{ dir: "asc", column: "" }],
            searchText: "",
          };
          const response = await ReceptionFreshService.FreshReceptionWeightComparison(params, userId);
          if (response && response.data) {
            rowsToProcess = Array.isArray(response.data)
              ? response.data
              : Array.isArray(response.data.data)
              ? response.data.data
              : [];
          }
        } catch (err) {
          console.error("Error al obtener datos para envío de correo:", err);
          this.$fun.alert("Ocurrió un error al preparar los datos.", "error");
          return;
        } finally {
          this.loadingMail = false;
        }
      }

      if (!rowsToProcess.length) {
        this.$fun.alert("No hay registros para enviar por correo.", "warning");
        return;
      }

      this.prepareEmailModalData(rowsToProcess);
      this.dialogPreviewMail = true;
    },
    prepareEmailModalData(rows) {
      const first = rows[0] || {};
      const producerName = String(first.PrdCardName || "PRODUCTOR").toUpperCase();

      this.textContent = `Estimado(a) <strong>${producerName}</strong>,<br><br>
        Adjunto a este correo encontrará el reporte en formato PDF correspondiente al <strong>Comparativo de Pesos de Recepción</strong>.<br><br>
        Atentamente,<br>
        <strong>Sunshine Export S.A.C - Área de Operaciones Agricolas</strong>`;

      this.selectedEmail = first.EmailProducer || first.PrdEmail || "";
      this.isEditing = false;
      this.isEditingEmail = false;

      const doc = this.buildPdfDocumentInstance(rows);
      this.pdfDocInstance = doc;
      this.pdfAttachmentName = `Comparativo_Pesos_Recepcion_${producerName.replace(/\s+/g, "_")}.pdf`;
      const dataUri = doc.output("datauristring");
      this.pdfAttachmentBase64 = dataUri.split(",")[1] || "";
    },
    enableEditing() {
      this.isEditing = true;
      this.$nextTick(() => {
        if (!this.quill) {
          this.quill = new Quill("#editor-reception", { theme: "snow" });
        }
        this.quill.clipboard.dangerouslyPasteHTML(this.textContent || "");
      });
    },
    saveText() {
      if (this.quill) this.textContent = this.quill.root.innerHTML;
      this.isEditing = false;
    },
    enableEmailEditing() {
      this.isEditingEmail = true;
      this.$nextTick(() => {
        if (this.$refs.emailInput) this.$refs.emailInput.focus();
      });
    },
    saveEmailText() {
      if (
        this.selectedEmail &&
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.selectedEmail)
      ) {
        this.$fun.alert("Por favor ingrese un correo válido.", "warning");
        return;
      }
      this.isEditingEmail = false;
    },
    downloadPdfPreview() {
      if (this.pdfDocInstance) {
        this.pdfDocInstance.save(this.pdfAttachmentName);
      }
    },
    async sendMailWithPdfAttachment() {
      if (
        !this.selectedEmail ||
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.selectedEmail)
      ) {
        this.$fun.alert("Por favor ingrese un correo destinatario válido.", "warning");
        return;
      }

      const correoPayload = {
        EmailPrs: this.selectedEmail,
        EmailBody: this.textContent,
        Affair: `Comparativo de Pesos de Recepción - Sunshine Export`,
        FileName: this.pdfAttachmentName,
        FileBase64: this.pdfAttachmentBase64,
      };

      const confirm = await this.$fun.alertFull("¿Está seguro de enviar el reporte por correo?", "question");
      if (!confirm || !confirm.value) return;

      this.sendingMail = true;
      try {
        await ReceptionFreshService.SendMail(correoPayload, this.$fun.getUserID());
        this.sendingMail = false;
        this.dialogPreviewMail = false;
        this.$fun.alert("El correo con el reporte PDF fue enviado correctamente.", "success");
      } catch (error) {
        console.error("Error al enviar correo con PDF:", error);
        this.sendingMail = false;
        this.$fun.alert("Ocurrió un error al enviar el correo.", "error");
      }
    },
    formatDate(value) {
      if (!value) return "-";
      const m = this.$moment(value);
      return m.isValid() ? m.format("DD/MM/YYYY") : String(value);
    },
    formatNumber(value) {
      if (value == null || isNaN(value)) return "0.00";
      return Number(value).toLocaleString("es-PE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    async onGeneratePdf() {
      this.loadingPdf = true;
      try {
        const userId = this.$fun.getUserID();
        const params = {
          filter: { ...this.filter },
          draw: 1,
          start: 0,
          length: 10000,
          order: [{ dir: "asc", column: "" }],
          searchText: "",
        };

        const response = await ReceptionFreshService.FreshReceptionWeightComparison(params, userId);
        let rows = [];
        if (response && response.data) {
          rows = Array.isArray(response.data)
            ? response.data
            : Array.isArray(response.data.data)
            ? response.data.data
            : [];
        }

        if (!rows.length) {
          this.$fun.alert("No hay datos para generar el reporte en PDF.", "warning");
          return;
        }

        this.buildPdfDocument(rows);
      } catch (error) {
        console.error("Error al generar PDF de comparación de pesos:", error);
        this.$fun.alert("Ocurrió un error al generar el PDF.", "error");
      } finally {
        this.loadingPdf = false;
      }
    },
    buildPdfDocumentInstance(rows) {
      const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a5" });
      const pageW = doc.internal.pageSize.getWidth(); // 210mm
      const pageH = doc.internal.pageSize.getHeight(); // 148mm
      const ml = 8;

      const first = rows[0] || {};
      const producerName = String(first.PrdCardName || "TODOS / VARIOS").toUpperCase();

      const totalWeightGuide = rows.reduce((s, r) => s + (parseFloat(r.RcfWeightGuide) || 0), 0);
      const totalNetWeight = rows.reduce((s, r) => s + (parseFloat(r.WbbNetWeight) || 0), 0);
      const diffWeight = totalNetWeight - totalWeightGuide;

      const drawHeaderFooter = (pageNum, totalPgs) => {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8.5);
        doc.setTextColor(0, 0, 0);
        doc.text("SUNSHINE EXPORT S.A.C", ml, 8);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(6);
        doc.setTextColor(60, 60, 60);
        doc.text("Carretera TamboGrande las Lomas Km 1077 + 179 Mts | RUC: 20329725431", ml, 11.5);
        doc.text("Área: RECEPCIÓN / PRODUCCIÓN FRESCO", ml, 14.5);

        doc.setDrawColor(180, 180, 180);
        doc.setLineWidth(0.2);
        doc.line(ml, pageH - 6, pageW - ml, pageH - 6);

        doc.setFontSize(6);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100, 100, 100);
        doc.text("SUNSHINE EXPORT S.A.C - Sistema SunExpert", ml, pageH - 2.5);
        doc.text(`Página ${pageNum} de ${totalPgs}`, pageW - ml, pageH - 2.5, { align: "right" });
      };

      let y = 20;
      const infoW = pageW - ml * 2; // 194mm

      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.1);
      doc.rect(ml, y, infoW, 11);

      doc.setFillColor(230, 230, 230);
      doc.rect(ml, y, infoW, 5, "F");
      doc.line(ml, y + 5, ml + infoW, y + 5);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(7.5);
      doc.setTextColor(0, 0, 0);
      doc.text(`DATOS DEL PRODUCTOR: ${producerName}`, ml + 3, y + 3.5);

      doc.setFontSize(7);
      const col1 = ml + 3;
      const col2 = ml + 70;
      const col3 = ml + 140;
      const rowY1 = y + 9.0;

      doc.setFont("helvetica", "bold"); doc.text("Fundo:", col1, rowY1);
      doc.setFont("helvetica", "normal"); doc.text(String(first.FagName || "-"), col1 + 10, rowY1);

      doc.setFont("helvetica", "bold"); doc.text("Lote / Zona:", col2, rowY1);
      doc.setFont("helvetica", "normal"); doc.text(`${first.FltName || "-"} (${first.ZonIDText || "-"})`, col2 + 16, rowY1);

      doc.setFont("helvetica", "bold"); doc.text("Cultivo / Var.:", col3, rowY1);
      doc.setFont("helvetica", "normal"); doc.text(`${first.TypeCultiveText || "-"} / ${first.VrtIDText || "-"}`, col3 + 18, rowY1);

      const tableHeaders = [
        "F. Cosecha",
        "F. Recepción",
        "N° Guía",
        "Fundo",
        "Lote",
        "Zona",
        "Peso Guía (kg)",
        "Peso Balanza (kg)",
        "Diferencia (kg)",
      ];

      const tableBody = rows.map((r) => {
        const wGuide = parseFloat(r.RcfWeightGuide) || 0;
        const wBalanza = parseFloat(r.WbbNetWeight) || 0;
        const diff = wBalanza - wGuide;
        return [
          this.formatDate(r.HvsDate),
          this.formatDate(r.RcfDateReception),
          r.RcfNumberReferralGuide || "-",
          r.FagName || "-",
          r.FltName || "-",
          r.ZonIDText || "-",
          this.formatNumber(wGuide),
          this.formatNumber(wBalanza),
          this.formatNumber(diff),
        ];
      });

      doc.autoTable({
        head: [tableHeaders],
        body: tableBody,
        startY: y + 16,
        margin: { left: ml, right: ml, bottom: 8 },
        theme: "grid",
        styles: {
          font: "helvetica",
          fontSize: 7,
          cellPadding: 2,
          textColor: [40, 40, 40],
          lineColor: [200, 200, 200],
          lineWidth: 0.1,
        },
        headStyles: {
          fillColor: [230, 230, 230],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          lineWidth: 0.2,
          lineColor: [150, 150, 150],
        },
        columnStyles: {
          0: { halign: "center", cellWidth: 18 },
          1: { halign: "center", cellWidth: 20 },
          2: { halign: "center", cellWidth: 24 },
          3: { halign: "left" },
          4: { halign: "center", cellWidth: 14 },
          5: { halign: "center", cellWidth: 22 },
          6: { halign: "right", cellWidth: 24 },
          7: { halign: "right", cellWidth: 25 },
          8: { halign: "right", cellWidth: 24 },
        },
        foot: [
          [
            "TOTALES",
            "",
            "",
            "",
            "",
            "",
            this.formatNumber(totalWeightGuide),
            this.formatNumber(totalNetWeight),
            this.formatNumber(diffWeight),
          ],
        ],
        footStyles: {
          fillColor: [240, 240, 240],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          halign: "right",
        },
        didParseCell: (data) => {
          if (data.section === "foot" && data.columnIndex === 0) {
            data.cell.styles.halign = "center";
          }
        },
      });

      const totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        drawHeaderFooter(i, totalPages);
      }

      return doc;
    },
    buildPdfDocument(rows) {
      const doc = this.buildPdfDocumentInstance(rows);
      const filename = `Comparacion_Pesos_Recepcion_${this.$moment().format("YYYYMMDD_HHmm")}.pdf`;
      doc.save(filename);
    },
  },
};
</script>

<style scoped>
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  white-space: nowrap;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  white-space: nowrap;
}

.email-container {
  max-width: 700px;
  margin: 0 auto;
  padding: 12px;
  font-family: Arial, sans-serif;
  color: #202124;
}

.email-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;
}

.email-title {
  font-size: 16px;
  font-weight: 500;
}

.email-label {
  background-color: #f1f3f4;
  color: #5f6368;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
}

.sender-info {
  display: flex;
  align-items: center;
  padding: 12px 0;
}

.profile-image {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 12px;
  border: 0.5px solid #c0c1c5;
}

.sender-details {
  flex-grow: 1;
}

.sender-email {
  font-weight: bold;
  font-size: 12px;
}

.recipient {
  font-size: 11px;
  color: #5f6368;
}

.email-content {
  padding: 10px 0;
  font-size: 13px;
}

.email-divider {
  height: 1px;
  background-color: #e0e0e0;
  margin: 12px 0;
}

.email-value {
  font-weight: 600;
  font-size: 13px;
}

#editor-reception ::v-deep .ql-editor {
  padding: 0 !important;
  min-height: 120px;
}

#editor-reception ::v-deep .ql-editor p {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1.4 !important;
}

.email-preview-content ::v-deep p {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1.4 !important;
}
</style>
